var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJokersystemetLogotyp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 329 148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#DF4C40",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#BB251E",
    stopOpacity: 0.6
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EE9018",
    fillRule: "nonzero",
    d: "M23.9 14.6a55 55 0 0 0-4 4.1c-2.5 2.7-1 4.6 2 3.2 15.8-7.9 33.6-4.4 43.4 11.4 11.5 18.5 18.7 35 6.5 50.4-1.3 1.6 23.7 13 25.5 11.4 22.2-20.3 28-55.6 7.8-77.8C84.8-5 46-5.7 23.9 14.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.7,
    cy: 125.7,
    r: 5.3,
    fill: "#EE9018",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.9,
    cy: 26.6,
    r: 5.3,
    fill: "#BB251E",
    fillRule: "nonzero",
    transform: "rotate(-82.2 12.9 26.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.3,
    cy: 25.3,
    r: 5.3,
    fill: "#EE9018",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "nonzero",
    d: "M182.2 132.7h-.8a54.9 54.9 0 1 1 5-109.5c3.4.3 4.4-3.2 1.3-5.3a70.7 70.7 0 1 0-4 119.3c2.8-1.7 1.8-4.6-1.5-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BD251F",
    d: "M56.6 32.9c12.1 0 23 4 31.7 10.5a62 62 0 0 1 18.4 22.8 43.5 43.5 0 0 1 4.9 21.3 67.9 67.9 0 0 1-8.2 28.4 59.8 59.8 0 0 1-10 12.6c-3 3-5.7 5.4-8 5.4-1 0-2.5-.6-2.4-2.3 0-2.6 2.2-7.5 2.5-13.2.6-16-13.8-36.7-36.8-36.7a35 35 0 0 0-24 9.5 47 47 0 0 0-10 14.8 23 23 0 0 0-1.9 8.6c0 3 .3 5.1-1.1 5.1C8.9 119.7.9 104 .9 88a54.5 54.5 0 0 1 55.7-55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    fillRule: "nonzero",
    d: "M163.4 146.7c-6.1 0-9.3-2.9-9.3-7.6V138h6.3v.9c0 1.6 1 2.4 2.7 2.4 1.8 0 2.3-.7 2.3-1.8 0-3.1-10.9-3-10.9-10.2 0-4.1 3.3-7.4 9-7.4 5.5 0 8.7 3 8.7 7.3v1.3h-6.4v-.8a2.1 2.1 0 0 0-2.4-2.4c-1.3 0-2 .6-2 1.8 0 3 11 2.8 11 10 0 4.1-3 7.6-9 7.6m23.8-10v9.3h-7.3v-9.3l-7.1-14.1h7.7l3.4 7.9 3.2-7.9h7.4l-7.3 14.1m7 2.3v-1h6.4v.9c0 1.6 1 2.4 2.6 2.4 1.8 0 2.4-.7 2.4-1.8 0-3.1-11-3-11-10.2 0-4.1 3.3-7.4 9-7.4 5.5 0 8.7 3 8.7 7.3v1.3H206v-.8a2.1 2.1 0 0 0-2.4-2.4c-1.4 0-2 .6-2 1.8 0 3 11 2.8 11 10 0 4.1-3 7.6-9 7.6-6.2 0-9.4-2.9-9.4-7.6zm32.4-10.7V146h-7.4v-17.7h-5.6v-5.7h18.6v5.7h-5.6m7.9 17.7v-23.4h16.7v5.6h-9.4v3.8h6.1v4.1h-6.1v3.9h9.4v6h-16.7m38 0v-13.4l-1.3 4.5-2.6 8.9h-4.5l-2.4-8.9-1.2-4.4V146h-6.6v-23.4h9.8l2.6 9.2.6 2.3.7-2.3 2.5-9.2h9.5V146h-7.1m10.4-23.4h16.7v5.6h-9.3v3.8h6.1v4.1h-6.1v3.9h9.3v6h-16.7zm31.4 5.7V146H307v-17.7h-5.6v-5.7H320v5.7h-5.7M74 54.3h18.1L79.2 97.8c3-1 5.5-2.6 7.5-4.9 0-.2.2-.3.4-.3h1a.4.4 0 0 1 .2.7c-1.6 3-3.4 6-5.3 9a23.8 23.8 0 0 1-14.2 10.6c-3.8 1-7.8 1.4-11.8 1.2H36.4L41 99.8h19.7L74 54.3zm77.8 31.2c-1.6 6-3.7 11.8-6.1 17.5a17.7 17.7 0 0 1-6 7.2c-2.5 1.8-5.4 3-8.5 3.6a104.6 104.6 0 0 1-20.7 1.2 42.5 42.5 0 0 1-11.2-2.2c-1.6-.6-3-1.5-4.4-2.7a10.7 10.7 0 0 1-2.7-4.2c-.7-2-.9-4-.6-6.1a130.7 130.7 0 0 1 6.6-26l3-8a14 14 0 0 1 2.6-4c1.5-1.6 3.3-2.9 5.2-3.8a32 32 0 0 1 8.4-2.8c4-.8 8-1.2 12.1-1.1l7.7.1c2.6.1 5.3.5 7.8 1.2a18 18 0 0 1 6.6 3.4c2 1.6 3.4 4 4 6.6v2.1c-1 6-2.2 12.1-3.8 18zm-18.5-.8c1.5-4.4 2.7-9 3.6-13.6.3-1 .1-2-.4-3a4.7 4.7 0 0 0-2.2-1.5c-1-.4-2-.6-3.1-.7a31 31 0 0 0-5.9 0c-1 .1-2 .3-3 .7-1 .3-2 .8-2.7 1.4a6 6 0 0 0-1.8 2.4 214.5 214.5 0 0 0-8 26.4c-.2 1-.2 1.9 0 2.8a4.6 4.6 0 0 0 3.5 3.3c1 .3 2 .4 3 .3a57.6 57.6 0 0 0 7.2-.7 9 9 0 0 0 3.2-1.6c.9-.7 1.5-1.7 1.7-2.8 1.9-4.5 3.5-9 5-13.4zm16 29.5 18.2-59.8h17.6L178.8 75l22-20.6h16.9l-31 27.3 15.6 32.5h-17.2l-10.6-25.1-7.6 25.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    fillRule: "nonzero",
    d: "M254.7 89.2H232c-.2 1.2-.6 2.4-1 3.7l-.8 3.6c0 .8.2 1.6.8 2.2.4.6 1.2 1 2 1.2a75.6 75.6 0 0 0 27.2-.6L256 114c-11 1.7-22.3 2-33.4.7-2.3-.2-4.4-1-6.1-2.5-1.6-1.4-2.8-3-3.6-5a20 20 0 0 1-1.4-6.4 27 27 0 0 1 .4-6.5A107.2 107.2 0 0 1 219 71l-2.4.7c-.9.1-1.7.4-2.6.6l-2.7 1.2c-1 .6-2 1.4-2.8 2.3l-.4.2a1 1 0 0 1-.9 0 .4.4 0 0 1-.2-.7c1.5-3 3.3-5.8 5.4-8.5 2-2.5 4.4-4.7 7-6.6a30.8 30.8 0 0 1 18.9-5.7h34.4l-4.4 14.3H243c-1 0-2 .3-2.7 1-.8.7-1.4 1.6-1.9 2.5-.5 1-1 2-1.3 3a9 9 0 0 1-1.3 2.6 24.9 24.9 0 0 1 5-.1h17.4l-3.5 11.5zm42.1 8.1h-11l-5 17h-17.4l18-59.6h30.2a20.6 20.6 0 0 1 11.5 3.2c1.6 1.1 3 2.6 4 4.2 1 1.9 1.5 4 1.4 6a33.2 33.2 0 0 1-9.6 23.4 22 22 0 0 1-5.6 4.2l6 18.5h-16.7l-5.8-17zm1.5-12.3c1.2 0 2.5 0 3.7-.3a9 9 0 0 0 2.5-.9 7 7 0 0 0 1.7-1.3l1.4-1.6a14.7 14.7 0 0 0 3.8-9.7c0-.7-.1-1.4-.3-2l-1-1.9a7 7 0 0 0-1.6-1.4 4 4 0 0 0-2-.5h-11l-6 19.6h8.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJokersystemetLogotyp);
export default __webpack_public_path__ + "static/media/jokersystemet_logotyp.d7460e84398f2c7c635cd5f332f65710.svg";
export { ForwardRef as ReactComponent };